import script from "./DynamicCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicCard.vue?vue&type=script&setup=true&lang=js"

import "./DynamicCard.vue?vue&type=style&index=0&id=44669df7&lang=css"
import "./DynamicCard.vue?vue&type=style&index=1&id=44669df7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44669df7"]])

export default __exports__